import Vue from 'vue'
const types = {
  SET_ACTIVE_FILTERS: 'SET_ACTIVE_FILTERS',
  SET_SEARCH_QUERY: 'SET_SEARCH_QUERY',
  SET_TABLE_FILTERS: 'SET_TABLE_FILTERS',
};
const state = {
  activeFilters: [],
  tableSearchQueries: {},
  tableFilters: {}
};

const mutations = {
  [types.SET_ACTIVE_FILTERS]: (state, value) => {
    state.activeFilters = value;
  },
  [types.SET_SEARCH_QUERY]: (state, query) => {
    let { entity, value } = query
    Vue.set(state.tableSearchQueries, entity, value)
  },
  [types.SET_TABLE_FILTERS]: (state, filter) => {
    let { entity, value } = filter
    Vue.set(state.tableFilters, entity, value)
  },
};

const actions = {};
const getters = {};

export default {
  namespaced: true,
  types,
  state,
  mutations,
  actions,
  getters
};
